var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyDefault({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2362",
    d: "M15 9L17.1494 9.64482C18.5226 10.0568 19.2092 10.2628 19.6046 10.7942C20 11.3256 20 12.0425 20 13.4761V21",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 8L10 8M7 12L10 12",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2360",
    d: "M11 21V18C11 17.0572 11 16.5858 10.7071 16.2929C10.4142 16 9.94281 16 9 16H8C7.05719 16 6.58579 16 6.29289 16.2929C6 16.5858 6 17.0572 6 18V21",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6003",
    d: "M1 21L21 21",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6728",
    d: "M2 21V5.71724C2 3.20649 2 1.95111 2.79118 1.32824C3.58237 0.705375 4.74742 1.04355 7.07752 1.7199L12.0775 3.17122C13.4836 3.57937 14.1867 3.78344 14.5933 4.33965C15 4.89587 15 5.65344 15 7.16857V21",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyDefault);
export default __webpack_public_path__ + "static/media/company-default.e32c03bad6752baa8dd4a36efb34473b.svg";
export { ForwardRef as ReactComponent };